import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mantine/core';
import { ChevronLeft, ChevronRight } from 'tabler-icons-react';
import AppStack from '../../common/AppStack';
import AppCard from '../../common/AppCard';
import AppText from '../../common/AppText';
import { useMediaQueryIndex } from '../../../helpers/hooks';
import AppFlexbox from '../../common/AppFlexbox';
import * as classes from '../../../styles/animations.module.css';

const CreationWizardCard = ({
  title,
  description,
  children,
  onContinue,
  onBack,
  onCreate,
  submitting,
  ...rest
}) => {
  const { isLargeMobileOrSmaller } = useMediaQueryIndex();

  return (
    <AppCard
      radius={isLargeMobileOrSmaller ? 0 : 'lg'}
      shadow="xl"
      withBorder
      {...rest}
      component="form"
      onSubmit={
        onCreate
          ? (e) => {
              e.preventDefault();
              onCreate();
            }
          : (e) => {
              e.preventDefault();
              onContinue();
            }
      }
      style={{
        width: '100%',
        padding: 0,
        ...rest.style
      }}
    >
      <AppStack
        className={classes.stackCardContent}
        style={{ minHeight: 200, padding: 25, paddingBottom: 10, gap: 10 }}
      >
        <AppStack style={{ gap: 0 }}>
          <AppText style={{ fontSize: 18, fontWeight: 500 }}>{title}</AppText>
          {description && (
            <AppText style={{ fontSize: 14, color: '#666' }}>
              {description}
            </AppText>
          )}
        </AppStack>

        {children}

        <AppFlexbox style={{ justifyContent: 'space-between', paddingTop: 10 }}>
          {onBack ? (
            <Button
              color="dark"
              disabled={submitting}
              leftSection={<ChevronLeft size={18} />}
              onClick={onBack}
              radius={8}
              size="sm"
              type="button"
              variant="subtle"
            >
              Back
            </Button>
          ) : (
            <AppFlexbox />
          )}

          {onCreate ? (
            <Button
              color="dark"
              loading={submitting}
              radius={8}
              rightSection={<ChevronRight size={18} />}
              size="sm"
              type="submit"
              variant="subtle"
            >
              Finish
            </Button>
          ) : onContinue ? (
            <Button
              color="dark"
              radius={8}
              rightSection={<ChevronRight size={18} />}
              size="sm"
              type="submit"
              variant="subtle"
            >
              Continue
            </Button>
          ) : (
            <AppFlexbox />
          )}
        </AppFlexbox>
      </AppStack>
    </AppCard>
  );
};

CreationWizardCard.propTypes = {
  children: PropTypes.node,
  description: PropTypes.string,
  onBack: PropTypes.func,
  onContinue: PropTypes.func,
  onCreate: PropTypes.func,
  submitting: PropTypes.bool,
  title: PropTypes.string
};

export default CreationWizardCard;
